<!--
 * @Author: Tang Yuxuan
 * @Date: 2020-10-12 14:46:03
 * @LastEditTime: 2020-10-30 09:26:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\writing\ai_writing.vue
-->
<!-- 智能生成 -->
<template>
  <div class="aiWriting">
    <div class="row">
      <el-tabs v-model="activeNames" @tab-click="handleClick">
        <el-tab-pane label="摘要" name="1"></el-tab-pane>
        <el-tab-pane label="致谢" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="non404" v-if="title.length < 5">
      <div>
        <img
          class="userimg"
          src="/static/images/non404_auto_sc.png"
          alt=""
          srcset=""
        />
        <p>输入不少于5字的标题后生成内容</p>
      </div>
    </div>
    <div
      class="box"
      v-if="title.length >= 5 && activeNames == '1'"
      v-loading="$root.stateType.aiAbstract"
      :element-loading-text="loadingText"
    >
      <div class="title_row">
        <span class="left_span"><span class="shu"></span> 中文摘要 </span>
        <button class="h_btn" @click="getAbstract('1')">
          <i class="el-icon-refresh-right"></i> 换一换
        </button>
      </div>
      <div class="list">
        <div
          class="list_row"
          v-for="(item, index) in ailist"
          :key="index"
          @click="selice(index)"
          :class="activeIndex == index ? 'activeIndex' : ''"
        >
          <div class="content">{{ item.content }}</div>
          <button class="copytext" @click="copyToClipBoard(item.content)">
            <i class="el-icon-document-copy"></i>
          </button>
        </div>
      </div>
      <!-- <div class="title_row">
            <span class="left_span"><span class="shu"></span> 英文摘要 </span>
        </div> -->
      <!-- <div class="list2" v-loading="enloading">
            <div class="list_row">
                <div class="content" :style="en == '' ? 'color:#989EA2' : ''">
                    {{ en || "选中中文摘要查看对应的英文摘要" }}
                </div>
                <button class="copytext" v-if="en != ''" @click="copyToClipBoard(en)">
                    <i class="el-icon-document-copy"></i>
                </button>
            </div>
        </div> -->
      <div class="btn_box" v-if="ailist.length != 0">
        <button
          class="get_ideas"
          :class="activeIndex == -1 ? 'no' : ''"
          @click="get_ideas()"
        >
          导入文中
        </button>
      </div>
    </div>
    <div
      class="box"
      v-if="title.length >= 5 && activeNames == '2'"
      v-loading="$root.stateType.aithank"
      element-loading-text="正在努力为您生成致谢"
    >
      <div class="title_row">
        <span class="left_span"><span class="shu"></span> 推荐致谢 </span>
        <button class="h_btn" @click="getAbstract('2')">
          <i class="el-icon-refresh-right"></i> 换一换
        </button>
      </div>
      <div class="list3">
        <div
          class="list_row"
          v-for="(item, index) in listData2"
          :key="index"
          @click="lookIndex = index"
          :class="lookIndex == index ? 'activeIndex' : ''"
        >
          <div class="content" v-show="lookpage != index">
            {{ item.content | spliceText(60) }}
            <button
              @click.stop="lookitem(index)"
              style="background:none;border:none;float: right;"
            >
              <img
                src="/static/images/resource_xiala_hover.png"
                alt=""
                srcset=""
              />
            </button>
          </div>
          <div class="content" v-show="lookpage == index">
            {{ item.content }}
            <button
              @click.stop="lookitem(index)"
              style="background:none;border:none;float: right;"
            >
              <img src="/static/images/writetop_shangla.png" alt="" srcset="" />
            </button>
          </div>
          <!-- <button class="copytext" @click="copyToClipBoard(item.content)">
                    <i class="el-icon-document-copy"></i>
                </button> -->
        </div>
      </div>
      <div class="btn_box" v-if="listData2.length != 0">
        <button
          class="get_ideas"
          :class="lookIndex == -1 ? 'no' : ''"
          @click="get_x()"
        >
          导入文中
        </button>
      </div>
    </div>

    <div class="limit-open-vip">
      <el-dialog 
       :close-on-click-modal= "false"
        :visible.sync="opneVipVisible"
        width="500px"
        top="30vh"
        title="导入论文">
        <div class="open-vip-box">
          <div class="open-vip-box-message">今日2次导入机会已用完，开通会员继续享受</div>
          <button
              @click="goVip"
              class="check-glod-btn"
              style="margin-right:16px"
            >
              <span class="check-btn-text">开通会员</span>
            </button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "activeName", "ailist", "listData2"],
  data: function() {
    return {
      loadingText: "正在努力为您生成摘要",
      Rloading: false,
      Rloading2: false,
      activeIndex: -1,
      lookIndex: -1,
      lookpage: -1,
      en: "", //"Powered underground railroad was replaced by the electrified underground railroad. Since then, the bus has gradually developed into the main body in the urban public transport structure. In the 1950s, streetcars developed slowly in some countries and were even taken off the road in some cities in the United States and Japan. However, trams still have certain advantages and use value, so in China and some European countries, they still appropriately retain their position in urban public transport. The development of trams is slow in some countries, so in China and some European countries, in the United States and Japan, some cities are even dismantled.",
      activeNames: "1",
      enloading: false,
      importTimes: 0,
      opneVipVisible: false
    };
  },
  components: {},
  created: function() {
    this.getImportTimes();
  },
  mounted: function() {
    this.activeNames = this.activeName;
  },
  methods: {
    lookitem(index) {
      this.lookpage != index ? (this.lookpage = index) : (this.lookpage = -1);
    },
    handleClick: function(tab, event) {
      console.log(tab, event);
      this.$emit("getsummary", tab.name);
    },
    selice: function(index) {
      this.activeIndex = index;
    },
    getAbstract: function(i) {
      this.lookIndex = -1;
      this.activeIndex = -1;
      this.en = "";
      this.$emit("getsummary", i);
    },

    copyToClipBoard: function(val) {
      var save = function(e) {
        e.clipboardData.setData("text/plain", val);
        e.preventDefault();
      };
      document.addEventListener("copy", save);
      document.execCommand("copy");
      document.removeEventListener("copy", save);
      let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 复制成功</div>`;
      this.$message({
        dangerouslyUseHTMLString: true,
        iconClass: "none",
        showClose: true,
        message: mgs,
        customClass: "mymessage",
        duration: 1000
      });
    },
    look: function(index) {
      this.listData2[index].look = true;
    },
    /**
     *插入中英文摘要 zAbstract 中文摘要 eAbstract英文摘要
     */
    get_ideas: function() {
      if (this.activeIndex == -1) {
        return false;
      }

      this.api.getToolsLimitCheck({type:4}).then(res => {
        if (res.code == 0) {
           document.getElementById(
              "editor"
            ).innerHTML = `<h1>摘要</h1><div id="zAbstract">${
              this.ailist[this.activeIndex].content
            }</div>${document.getElementById("editor").innerHTML}`;
            this.$emit("saveWriting", "true");
        } else {
          this.opneVipVisible = true;
        }
      })
    },
    get_x: function() {
      this.api.getToolsLimitCheck({type: 4}).then(res => {
        if( res.code == 0) {
            document.getElementById("editor").innerHTML =
            document.getElementById("editor").innerHTML +
            `<h1>致谢</h1><div id="thank">${
              this.listData2[this.lookIndex].content
            }</div>`;

          this.$emit("saveWriting", "true");
        } else {
          this.opneVipVisible = true;
        }
      })
    },

    // 校验导入原文的次数 (这个地方用次数表示，没有用true 或false表示，主要是考虑后期提示的次数是否需要从后台读取的可配置数据)
    validateImportTimes: function() {
      let _this = this;
      this.api
        .getToolsLimitCheck({
          type: 3
        })
        .then(res => {
          if (res.code == 0) {
            this.importTimes = 1;
          } else {
            this.importTimes = 0;
          }
        });
    },
    /** 获取导入次数 */
    getImportTimes() {
        this.api.getToolsLimitCheck({
          type: 3
        }).then(res => {
            if (res.code == 0) {
                this.importTimes = 1;
            } else{
                this.importTimes = 0;
            }
        })
    },

    goVip() {
      this.opneVipVisible = false;
      this.$parent.goVip();
    }
  }
};
</script>

<style lang="scss" scoped>
.aiWriting {
  padding-left: 40px;

  .box {
    height: calc(100vh - 100px);
    overflow: auto;
  }

  .row {
    display: flex;
    justify-content: center;
    height: 100px;
    align-items: center;
  }

  .non404 {
    text-align: center;
    margin-top: 168px;

    img {
      height: 111px;
    }

    p {
      margin-top: 38px;
      font-size: 14px;
      color: #989ea2;
      line-height: 22px;
    }
  }

  .title_row {
    color: $btnc;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    padding-right: 40px;

    .left_span {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: bold;

      .shu {
        border-left: 4px solid $btnc;
        height: 18px;
        display: inline-block;
        margin-right: 12px;
      }
    }

    .text {
      font-size: 14px;
      font-weight: 400;
      color: #989ea2;
    }

    .h_btn {
      color: $btnc;
      border: none;
      background: none;
      border-radius: 20px;
      font-size: 14px;
      height: 28px;
    }
  }

  .list {
    height: calc(100vh - 340px);
    overflow: auto;
    padding-right: 40px;
  }

  .list3 {
    height: calc(100vh - 340px);
    overflow: auto;
    padding-right: 40px;

    .list_row {
      border: 1px solid #eeeeee;
      border-radius: 4px;
      padding: 16px 0px 24px 20px !important;
    }

    .content {
      height: auto !important;
      padding-right: 16px;
    }
  }

  .list_row + .list_row {
    margin-top: 16px;
  }

  .activeIndex {
    border-left: 4px solid !important;
    border-color: $btnc !important;
  }

  .list_row {
    border: 1px solid #eeeeee;
    border-radius: 4px;
    padding: 16px 0px 24px 20px !important;

    .content {
      padding-right: 16px;
    }

    .copytext {
      float: right;
      font-size: 15px;
      background: none;
      border: none;
      color: #989ea2;
    }

    .copytext:hover {
      color: $btnc;
    }
  }

  .btn_box {
    height: 96px;
    line-height: 96px;
    text-align: center;

    .no {
      background: linear-gradient(0deg, #8a8a8a 0%, #a8a8a8 100%) !important;
    }

    .get_ideas {
      border: none;
      width: 240px;
      height: 36px;
      background: linear-gradient(0deg, #5676bd 0%, #6687c8 100%);
      border-radius: 18px;
      color: #ffffff;
    }
  }

  .limit-open-vip {
   /deep/ .el-dialog__title{
     font-weight: bold;
   }
 }

   .open-vip-box{
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:space-between;

    .open-vip-box-message{
      margin-bottom: 20px;
    }

    .check-glod-btn {
      width: 134px;
      height: 36px;
      background: #c79758;
      opacity: 1;
      border-radius: 18px;
      border: none;
    }
    .check-btn-text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 12px;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/ai.vue